import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/Competence/CompetenceTaskAttachmentApi";

export class CompetenceTaskAttachmentService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editCompetenceTaskAttachment", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editCompetenceTaskAttachment");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getCompetenceTaskAttachments", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getCompetenceTaskAttachment", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createCompetenceTaskAttachment", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteCompetenceTaskAttachment", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editCompetenceTaskAttachment", model);
  }
  async acceptFiles(gfids, competenceTaskId) {
    return this.setStatus(gfids, competenceTaskId, 0);
  }
  async errorFiles(gfids, competenceTaskId) {
    return await this.setStatus(gfids, competenceTaskId, 255);
  }
  async setStatus(gfids, competenceTaskId, status) {
    var models = gfids.map(x => {
      return {
        id: 0,
        fileName: "",
        gfid: x,
        competenceTaskId: competenceTaskId,
        statusFlag: status,
        disabled: false
      }
    })
    return await this.transformer.editItem(this.Api, "setStatusCompetenceTaskAttachment", models);
  }
}
